/**
 * @internal
 */
export function buildAvailableStateQuery(availableState) {
    if (!availableState) {
        return '';
    }
    return "&availableState=" + availableState;
}
